/* eslint-disable */

/** unique or primary key constraints on table "argo.auth_provider_msal" */
export enum ArgoAuthProviderMsalConstraint {
  /** unique or primary key constraint on columns "auth_provider_record_id" */
  AuthProviderMsalAuthProviderRecordIdKey = 'auth_provider_msal_auth_provider_record_id_key',
  /** unique or primary key constraint on columns "home_account_id" */
  AuthProviderMsalHomeAccountIdKey = 'auth_provider_msal_home_account_id_key',
  /** unique or primary key constraint on columns "auth_provider_msal_id" */
  AuthProviderMsalPkey = 'auth_provider_msal_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AuthProviderMsalUserId = 'auth_provider_msal_user_id'
}

/** select columns of table "argo.auth_provider_msal" */
export enum ArgoAuthProviderMsalSelectColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  HomeAccountId = 'home_account_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Rsp = 'rsp',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "argo.auth_provider_msal" */
export enum ArgoAuthProviderMsalUpdateColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  HasuraRole = 'hasura_role',
  /** column name */
  HomeAccountId = 'home_account_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Rsp = 'rsp',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

